import { render, staticRenderFns } from "./ViewAuditSampleSize.vue?vue&type=template&id=2bbcbae8&scoped=true"
import script from "./ViewAuditSampleSize.vue?vue&type=script&lang=js"
export * from "./ViewAuditSampleSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbcbae8",
  null
  
)

export default component.exports